import Vue from 'vue'
import axios from 'axios'
import Qs from 'qs'
import 'babel-polyfill'
import promise from 'es6-promise'
import loading from './loading'
import timeout from './timeout'
import global from './global'
import store from '@/store/store'
promise.polyfill()

const $axios = axios.create({
    // 正式环境后端推荐5s 线上图片识别接口较慢，改成10s超时
    timeout: 10000,
    withCredentials: true // 允许携带cookie
});

const params = {
    body: "{}"
};

let href = location.href;
let host = href.split("#")[0];
let notLoginAddress = host + '#/notLogin';

//请求拦截器
$axios.interceptors.request.use((config) => {
    if (navigator.onLine) {
        loading.showLoading();
        return config;
    } else {
        Vue.prototype.$toast('无可用网络,请检查...', 3000);
    };
}, (error) => {
    return Promise.reject(error);
})

//响应拦截器
$axios.interceptors.response.use((response) => {
    loading.hideLoading();
    return response;
}, (error) => {
    // console.log(error.response.status);
    if (error.code.toString() == 'ECONNABORTED' && error.message.indexOf('timeout') != -1) {
        //请求超时
        loading.hideLoading();
        timeout.timeout();
    }
    return Promise.reject(error);
})

//
const codeMessage = {
    401: '用户没有权限（令牌、用户名、密码错误）。',
    500: '服务器发生错误，请检查服务器。'
};

export default {
    recalc() {
        let docEl = document.documentElement;
        let clientWidth = docEl.clientWidth || document.body.clientWidth || window.innerWidth || window.screen.width;//��Щ���ͻ�webview��ȡ������ߣ���Ҫ���ݴ���

        if (!clientWidth) return;
        if (clientWidth > 640) {
            clientWidth = 640;
        } else if (clientWidth < 320) {
            clientWidth = 320;
        }
        docEl.style.fontSize = 20 * (clientWidth / 375) + 'px';
    },
    throttle(fn, delay) {
        let timer = null;
        return function () {
            timer && clearTimeout(timer);
            timer = setTimeout(function () {
                fn();
            }, delay);
        };
    },
    setRootFont() {
        let self = this;
        let throttleFn = self.throttle(self.recalc, 100);
        let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
        if (document.addEventListener) {
            window.addEventListener(resizeEvt, function () {
                throttleFn();
            }, false);
            document.addEventListener('DOMContentLoaded', function () {
                throttleFn();
            }, false);
        }
    },
    /**
     * 发送异步请求
     * @param option
     *          url : 请求的地址
     *          params : 请求参数
     *          sc : 成功回调
     *          fc : 失败回调
     */
    post(option) {
        let self = this;
        params.t = new Date().getTime();

        if(this.isFromNewWs()){
            params.appid = 'b2b';
            params.loginType = 2;
        }else{
            params.appid = 'fenxiaoh5';
            params.loginType = 9;
        }

        if (this.isAndroid()) {
            params.client = "apph5-android";
            //添加用户当前选中的渠道入参
            self.getChooseChannel((res) => {
                if (res) {
                    params.uts = res;
                }
            });
        } else if (this.isIOS()) { //ios提供的方法是异步的，有延迟，改用全局变量
            params.client = "apph5-apple";
            const channel = window.native_userChoiceChannel;
            if (channel) {
                params.uts = channel;
            }
        }

        if (option.params) {
            option.params = Object.assign({}, params, option.params);
        }
        for (let key in option.params) {
            if (typeof (option.params[key]) == "undefined") {
                option.params[key] = '';
            }
        }
        $axios({
            method: 'post',
            url: global.API_CONFIG[process.env.BUILD_ENV] + global.API_CONFIG.api_name,
            data: Qs.stringify(option.params)
        }).then(function (res) {
            res = res.data;
            switch (res.code.toString()) {
                case '0':
                    if (option.sc) {
                        option.sc(res);
                    }
                    break;
                case '3': //未登陆
                    let currentUrl = location.href || global.PAGE_CONFIG[process.env.BUILD_ENV];
                    if(global.LOGIN_TYPE === 5){
                        location.href = '//jlogin.m.jd.com/fx/mlogin?appid=' + params.appid + '&returnurl=' + currentUrl;
                    } else if ((global.LOGIN_TYPE === 9) || (global.LOGIN_TYPE === 2)) {
                        //未登录情况应该调用原生方法退出登录 当版本号获取异常时 需要切换为B商城网络配置重试
                        if( !store.state.appVerInfo || !store.state.appVerInfo.verCode || store.state.appVerInfo.verCode === '1.0.4'){
                          option.params.appid = 'b2b';
                          option.params.loginType = 2;
                          $axios({
                              method: 'post',
                              url: global.API_CONFIG[process.env.BUILD_ENV] + global.API_CONFIG.api_name,
                              data: Qs.stringify(option.params)
                            }).then(function (res) {
                              res = res.data;
                              switch (res.code.toString()) {
                                  case '0':
                                      if (option.sc) {
                                          option.sc(res);
                                      }
                                      break;
                                  case '3': //未登陆
                                      self.jumpToRN('loginOut');
                                      break;
                                  default:
                                      if (option.fc) {
                                          option.fc(res);
                                      }
                                      break;
                              }
                          });
                        }else{
                            self.jumpToRN('loginOut');
                        }
                    } else {
                        location.href = '//jlogin.m.jd.com/fx/mlogin?appid=' + params.appid + '&returnurl=' + currentUrl;
                    }
                    break;
                /*case '2004':
                    location.href = notLoginAddress;
                    location.reload();
                    break;*/
                default:
                    if (option.fc) {
                        option.fc(res);
                    }
                    break;
            }
        });
    },
    get(option) {
        let self = this;
        params.t = new Date().getTime();

        if(this.isFromNewWs()){
            params.appid = 'b2b';
            params.loginType = 2;
        }else{
            params.appid = 'fenxiaoh5';
            params.loginType = 9;
        }
      
        if (this.isAndroid()) {
            params.client = "apph5-android";
            //添加用户当前选中的渠道入参
            self.getChooseChannel((res) => {
                if (res) {
                    params.uts = res;
                }
            });
        } else if (this.isIOS()) { //ios提供的方法是异步的，有延迟，改用全局变量
            params.client = "apph5-apple";
            const channel = window.native_userChoiceChannel;
            if (channel) {
                params.uts = channel;
            }
        }

        if (option.params) {
            option.params = Object.assign({}, params, option.params);
        }
        $axios.get(global.API_CONFIG[process.env.BUILD_ENV] + global.API_CONFIG.api_name, {
            params: option.params
        }).then(function (res) {
            res = res.data;
            switch (res.code.toString()) {
                case '0':
                    if (option.sc) {
                        option.sc(res);
                    }
                    break;
                case '3': //未登陆
                    let currentUrl = location.href || global.PAGE_CONFIG[process.env.BUILD_ENV];
                    if(global.LOGIN_TYPE === 5){
                        location.href = '//jlogin.m.jd.com/fx/mlogin?appid=' + params.appid + '&returnurl=' + currentUrl;
                    } else if ((global.LOGIN_TYPE === 9) || (global.LOGIN_TYPE === 2)) {
                        //未登录情况应该调用原生方法退出登录 当版本号获取异常时 需要切换为B商城网络配置重试
                        if( !store.state.appVerInfo || !store.state.appVerInfo.verCode || store.state.appVerInfo.verCode === '1.0.4'){
                          option.params.appid = 'b2b';
                          option.params.loginType = 2;
                          $axios.get(global.API_CONFIG[process.env.BUILD_ENV] + global.API_CONFIG.api_name, {
                              params: option.params
                          }).then(function (res) {
                              res = res.data;
                              switch (res.code.toString()) {
                                  case '0':
                                      if (option.sc) {
                                          option.sc(res);
                                      }
                                      break;
                                  case '3': //未登陆
                                      self.jumpToRN('loginOut');
                                      break;
                                  default:
                                      if (option.fc) {
                                          option.fc(res);
                                      }
                                      break;
                              }
                          });
                        }else{
                            self.jumpToRN('loginOut');
                        }
                    } else {
                        location.href = '//jlogin.m.jd.com/fx/mlogin?appid=' + params.appid + '&returnurl=' + currentUrl;
                    }
                    break;
                /*case '2004':
                    location.href = notLoginAddress;
                    location.reload();
                    break;*/
                default:
                    if (option.fc) {
                        option.fc(res);
                    }
                    break;
            }
        });
    },
    //上传文件回调
    upLoadFileCallback(resJson, sc, fc) {
        switch (resJson.id.toString()) {
            case '1':
                if (sc) {
                    sc(resJson);
                }
                break;
            default:
                if (fc) {
                    fc(resJson);
                }
                break;
        }
    },
    formatStrToDate(str) {
        let date;
        date = new Date(Date.parse(str.replace(/-/g, "/")));
        return date;
    },
    //转换时间格式
    parseDate(str, type) {
        if (!str) {
            return '';
        }
        var date = new Date(str);
        if (isNaN(date)) {
            return str;
        }
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        month = month >= 10 ? month : "0" + month;
        var day = date.getDate();
        day = day >= 10 ? day : "0" + day;
        var hour = date.getHours();
        hour = hour >= 10 ? hour : "0" + hour;
        var minute = date.getMinutes();
        minute = minute >= 10 ? minute : "0" + minute;
        var second = date.getSeconds();
        second = second >= 10 ? second : "0" + second;
        switch (type) {
            case "short": //短格式，如2011-05-06
                return year + "-" + month + "-" + day;
                break;
            case "long": //长格式，如2011-05-06 10:05:06
                return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                break;
            case "chinese": //中文格式，2011年05月06日 23:09
                return year + "年" + month + "月" + day + "日 " + hour + ":" + minute;
                break;
            default:
                return str;
                break;
        }
    },
    // 获取url参数
    getUrlParam(paramName, urlStr) {
        let href = urlStr || window.location.href;
        let url = decodeURI(href);
        let idx = url.indexOf("?");
        let params = url.substring(idx + 1);
        if (params) {
            params = params.split("&");
            for (let i = 0, length = params.length; i < length; i++) {
                let param = params[i].split("=");
                if (param[0] == paramName) {
                    let pArr = [];
                    for (let k = 1, len = param.length; k < len; k++) {
                        pArr.push(param[k]);
                    }
                    let p = pArr.join('=');
                    let idx1 = p.indexOf("#");
                    if (idx1 != -1) {
                        p = p.substring(0, idx1);
                    }
                    return p;
                }
            }
        }
    },
    //过滤URL脚本
    filterScript(str) {
        str = str || "";
        str = str.replace(/<.*>/g, ""); //过滤标签注入
        str = str.replace(/(java|vb|action)script/gi, ""); //过滤脚本注入
        str = str.replace(/[\"\'][\s ]*([^=\"\'\s ]+[\s ]*=[\s ]*[\"\']?[^\"\']+[\"\']?)+/gi, ""); //过滤HTML属性注入
        str = str.replace(/[\s ]/g, "&nbsp;"); //替换空格
        return str;
    },
    isAndroid() {
        let u = navigator.userAgent;
        return u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
    },
    isIOS() {
        let u = navigator.userAgent;
        return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    },
    //跳转到RN
    jumpToRN(module, nativeModule, pageParam) {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        // 跳转安卓
        if (isAndroid) {
            let toNativeUrl = "openapp.personalcenter://virtual";
            let toNativeParams = {
                category: "jump",
                des: "HelloWorld",
                modulename: nativeModule || "",
                appname: nativeModule || "",
                ishidden: true,
                param: {
                    pageType: module,
                    pageParam: pageParam || ""
                }
            }
            let toNativeParamsStr = JSON.stringify(toNativeParams);
            let toNative = `${toNativeUrl}?params=${toNativeParamsStr}`;
            let getData = {
                "businessType": module,
                "callBackName": 'callback',
                "params": {
                    "key": toNative
                }
            };
            // alert(JSON.stringify(getData));
            window.JDWebView && window.JDWebView.asyncToNative(JSON.stringify(getData));
        }

        // 跳转ios
        if (isIOS) {
            let toNativeUrl = "openapp.jdwsmobileios://virtual";
            let toNativeParams = {
                category: "jump",
                des: "jdreactcommon",
                modulename: nativeModule || "",
                appname: nativeModule || "",
                ishidden: true,
                param: {
                    pageType: module,
                    pageParam: pageParam || ""
                }
            };
            let toNativeParamsStr = JSON.stringify(toNativeParams);
            let toNative = `${toNativeUrl}?params=${toNativeParamsStr}`;
            window.location.href = toNative;
        }
    },
    //页面埋点
    MPingClick(eventId) {
        try { //点击流处理                   // 必选参数，事件id
            let click = new MPing.inputs.Click(eventId);        // 构造点击上报对象
            click.updateEventSeries();                           // 更新事件串
            (new MPing()).send(click);                           // 构造上报实例，上报点击事件
        } catch (e) { }
    },
    //计算字符串字符总数
    strLen(str) {
        let len = 0;//中文汉字数
        for (let i = 0; i < str.length; i++) {
            if (this.isCHS(str[i])) {
                len += 2;
            } else {
                len++;
            }
        }
        return len;
    },
    //判断某个字符是否为汉字
    isCHS(str) {
        if (str.charCodeAt(0) > 255 || str.charCodeAt(0) < 0)
            return true;
        else
            return false;
    },
    //将字符串拆成字符，并存到数组中
    strToCharsCH(str) {
        let chars = [];
        for (let i = 0; i < str.length; i++) {
            chars[i] = [str.substr(i, 1), this.isCHS(str[i])];
        }
        return chars;
    },
    //截取字符串（从start字节截取length个字节）
    subCHStr(str, start, length) {
        let len = 0;
        let retStr = "";
        let charsArray = this.strToCharsCH(str);
        for (let i = 0; i < str.length; i++) {
            if (charsArray[i][1])
                len += 2;
            else
                len++;
            if ((start + length) < len)
                return retStr;
            else if (start < len)
                retStr += charsArray[i][0];
        }
        return retStr;
    },
    //是否是新版版本的版本号，新版存入本地的包含小数点，老版是build值
    isNewIosVersion(appVer) {
        if (String(appVer).indexOf('.') > -1) {
            return true;
        }
        return false;
    },

    /**
     * 新版ios版本当前版本是否大于某个版本 新版版本包含小数点，如3.0.0，包含3段 3.1.2
     * @param currentVer 当前客户端版本
     * @param cmpVer 待比较的版本
     * @returns {boolean}
     */
    isNewIosVersionHigher(currentVer, cmpVer) {
        let cmpVerArr = String(cmpVer).split('.');
        let currentVerArr = String(currentVer).split('.');
        let ret = false;
        for (let i = 0, len = currentVerArr.length; i < len; i++) {
            if (currentVerArr[i] - cmpVerArr[i] > 0) {
                ret = true;
                break;
            } else if (currentVerArr[i] - cmpVerArr[i] < 0) {
                break;
            }
        }
        return ret;
    },
    //获取APP版本号相关的信息
    getAppVersion(cb) {
        if (this.isAndroid()) {
            const versionInfo = (window.Android && window.Android.getVersionInfo) ? JSON.parse(window.Android.getVersionInfo()) : {};
            versionInfo.version = versionInfo.appMainVer; //ios和Android使用相同的版本号属性名version
            cb(versionInfo); //versionInfo对象中appMainVer对应的是版本名称；如1.0.6。verCode 对应的就是一个和版本名称对应的int值
        } else if (this.isIOS()) {
            // 通过ios初始化方法判断是否为新版本
            if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.getVersionInfo && window.webkit.messageHandlers.getVersionInfo.postMessage) {
                //发送消息给客户端，获取当前版本号
                // window.fillVersion = function(res) {
                //     if(res){
                //         var isNewIosVersionHigher = (currentVer,cmpVer) =>{
                //             var cmpVerArr = String(cmpVer).split('.');
                //             var currentVerArr = String(currentVer).split('.');
                //             var ret = false;
                //             for(var i = 0, len = currentVerArr.length; i < len; i++){
                //                 if(currentVerArr[i] - cmpVerArr[i] > 0){
                //                     ret = true;
                //                     break;
                //                 }
                //             }
                //             return ret;
                //         };
                //         const versionInfo =  JSON.parse(res) || {};
                //         //3.0.0以上版本使用version字段里的版本号；老版本继续使用biuld，最终会存入本地store
                //         let curVersion = versionInfo.version;
                //         if(isNewIosVersionHigher(curVersion, '3.0.0')){
                //             versionInfo.verCode = curVersion;
                //         }else{
                //             versionInfo.verCode = versionInfo.biuld; //ios和Android使用相同的版本号整数值属性名verCode
                //         }
                //         cb(versionInfo);
                //     }
                // };
                window.fillVersion = function (res) {
                    if (res) {
                        const versionInfo = JSON.parse(res) || {};
                        //ios和Android使用相同的版本号整数值属性名verCode 所有版本都使用version替换biuld
                        versionInfo.verCode = versionInfo.version;
                        cb(versionInfo);
                    }
                };
                window.webkit.messageHandlers.getVersionInfo.postMessage(null);
            } else { //1.0.4 暂时不删，本地测试使用此逻辑，本地测试用
                cb({
                    version: '1.0.4',
                    verCode: '1.0.4'
                });
            }

        }
    },
    //ios系统获取暗黑模式
    getDarkMode(cb) {
        // 通过ios初始化方法判断暗黑模式
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.getAppearanceStyle && window.webkit.messageHandlers.getAppearanceStyle.postMessage) {
            //发送消息给客户端
            window.appearanceChanged = function (res) {
                if (res) {
                    const mode = res === 'WSAppearanceStyleDark' ? true : false;
                    cb(mode);
                }
            };
            window.webkit.messageHandlers.getAppearanceStyle.postMessage(null);
        } else {
            cb(false);
        }
    },
    //从客户端获取用户当前选择的渠道 只有android会调用，无需做客户端的判断
    getChooseChannel(cb) {
        const userChooseChannel = (window.Android && window.Android.getUserState) ? window.Android.getUserState() : '';
        cb(userChooseChannel);
    },
    //注册客户端回调
    registerCallback(cb) {
        //注册全局回调函数
        window.globalCallback = (jsonString) => {
            const jsonObj = JSON.parse(jsonString);
            cb(jsonObj);
            /*switch(jsonObj.status){
                case 'openScan':
                    cb(jsonObj);
                    break;
            }*/
        }
    },
    //判断二维码信息是否是下载页地址+code
    isSafariPageUrl(urlStr) {
        if (urlStr.indexOf('https://b2bapp-h5.jd.com/#/safariPage') > -1 ||
            urlStr.indexOf('https://b2bapp-h5-preview.jd.com/#/safariPage') > -1) {
            let code = this.filterScript(this.getUrlParam("code", urlStr));
            if (code) {
                return code;
            }
        }
        return false;
    },
    getCurrentDomain() {
        let href = location.href;
        let host = href.split("#")[0];
        return host;
    },
    adaptDetailImg(el, native) {
        let pageWidth = document.body.clientWidth,
            pDiv = el.parentNode,
            w = el.offsetWidth,
            h = el.offsetHeight,
            cw = (window.isMScene && pageWidth > 640 ? 640 : pageWidth);

        if (w > 0) {
            var scale = cw / w;
            if (scale < 1) {
                el.style.WebkitTransformOrigin = 0 + 'px ' + 0 + 'px';
                el.style.transformOrigin = 0 + 'px ' + 0 + 'px';
                el.style.WebkitTransform = 'scale(' + scale + ')';
                el.style.transform = 'scale(' + scale + ')';
                pDiv.style.width = (w * scale) + 'px';
                pDiv.style.height = (h * scale + 46) + 'px';
                if (native) {
                    if (this.isAndroid()) {
                        window.App.resize(h * scale + 46);
                    }
                }
            }
            if (scale && Math.ceil(12 / scale) > 10) {
                el.style.fontSize = Math.ceil(12 / scale) + 'px';
            }
        }
    },
    //字符串驼峰转中横线（默认中横线）
    camelToLine(camelStr, lineType = '-') {
        let lineStr = camelStr.replace(/[A-Z]/g, (match) => {
            return lineType + match.toLowerCase();
        });
        //如果首字母是大写，执行replace时会多一个-，需要去掉
        if (lineStr.slice(0, 1) === lineType) {
            lineStr = lineStr.slice(1);
        }
        return lineStr;
    },
    //校验手机号
    validMobile(phoneNum) {
        // let reg = /^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,7,8]|8[0-9]|9[1,8,9])\d{8}$/;
        //先使用宽泛的校验
        let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        return reg.test(phoneNum);
    },
    isFromNewWs(){
        if (this.isAndroid()) {
            //获取安卓版本号 35以上的版本为B商城app 其他情况默认是老万商
            let verCode = store.state.appVerInfo && store.state.appVerInfo.verCode ? Number.parseInt(store.state.appVerInfo.verCode) : 1;
            if(verCode > 35){
                return true;
            }else{
                return false;
            }
        }else if (this.isIOS()) {
            //获取ios版本号 4.0.4以上的版本为B商城app 其他情况默认是老万商
            let verCode = store.state.appVerInfo && store.state.appVerInfo.verCode ? store.state.appVerInfo.verCode : '1.0.4';
            if(this.isNewIosVersionHigher(verCode, '4.0.4' ))
            {
                return true;
            }else {
                return false;
            }
        }else{
            return false;
        }
    },
}


// WEBPACK FOOTER //
// ./src/common/js/util.js